import Slider from "../../componnets/Slider/Slider";
import Button from 'react-bootstrap/Button';
import Card  from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import "./profile.scss";
import { useEffect, useRef } from "react";
import { init } from "ityped";
import {School,Work,Code,Contacts} from "@material-ui/icons"
import { Link } from "react-router-dom";



export default function Profile() {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed:60,
      strings: ["Fontend", "Backend", "Ful Stack"],
    });
  }, []);
  
  return (
    <>
    <div >
<Slider/>
{/*<div>
  <h1>Bienvenue Dans mon site Web</h1>
  <p style={{  fontSize:"30px"
}}>Désireuse de développer constamment mes compétences afin d'assurer mon évolution professionnelle, 

<br/>
je suis confiante en ma capacité à proposer des idées intéressantes</p>
</div>*/}
<Card className="text-center"  style={{backgroundColor:"none"}}>
      <Card.Header className="cardHeader">
      <img
                className="profileUserImg"
                src={
                  "../diamelle/IMG-20220921-WA0001.jpg"
                }
                alt=""
              />
      <h1>Siwar Samaali</h1></Card.Header>
      <Card.Body>
        <Card.Title>À propos de mois</Card.Title>
        <Card.Text>
        <p>Je suis <strong>Siwar Samaali </strong>
       une jeune diplômée en <strong> licence en sciences de l'informatique</strong> parcours
       <strong> informatique multimédia </strong> <br/>
       je suis à la recherche d'une opportunité de travail en tant que
       <br/>    
       Développeur ;
        <span ref={textRef} className="span"></span></p>
        </Card.Text>
       <Button variant="light"> <a href="http://parcours-lmd.salima.tn/listeueetab.php?parc=V09ZFA0iVjcENQF7BztRYgguXGM=&etab=AGVYagA1">Savoir plus sur mes étude <School/></a></Button>
      </Card.Body>
    </Card>
    {/*
    <a href="https://google.com" class="cardi">
      <div class="inner" >
      <p>Désireuse de développer constamment mes compétences afin d'assurer mon évolution professionnelle, 

<br/>
je suis confiante en ma capacité à proposer des idées intéressantes </p>       
      </div>
  </a>
        
    
    <CardGroup>
    <div className="twice">
    <Card className="text-center"  style={{backgroundColor:"none"}}>
        <p>Désireuse de développer constamment mes compétences afin d'assurer mon évolution professionnelle, 

        <br/>
        je suis confiante en ma capacité à proposer des idées intéressantes </p>
        </Card>
    <Card className="text-center"  style={{backgroundColor:"none"}}>
        <img className="ima" src="./IMG_2510.JPG" alt=""></img>
      </Card>
      
      </div>
      </CardGroup>
      */}
    <div>
    
      <CardGroup>

      <Card className="text-center container">
        <Card.Img  className="image" variant="top" src="https://upload.itg.fr/files/competences-freelance.jpg" />
        <Card.Body>
        <Link to={"/competence"}>
        <button className="middle">Consulter</button>
        </Link>
          <Card.Title className="text">  <Code/> mes compétences</Card.Title>

        </Card.Body>

       
      </Card>
   
      <Card className="text-center container">
        <Card.Img className="image" variant="top" src="https://www.lafabriquedunet.fr/wp-content/uploads/2015/10/exemple-site-vitrine.png" />
        <Card.Body>
        <Link to={"/project"}>
        <button className="middle">Consulter</button>
        </Link>
          <Card.Title className="text">   <Work/> Mes projets</Card.Title>
          
        </Card.Body>
        
      </Card>
      <Card className="text-center container">
        <Card.Img  className="image" variant="top" src="https://s3-eu-central-1.amazonaws.com/lycamobilespain-website/lycamobile-es-cms/wp-content/uploads/2017/05/16142305/contact-us.png" />
        <Card.Body>
        <Link to={"/contact"}>
        <button className="middle">Consulter</button>
        </Link>
          <Card.Title className="text">   <Contacts/> contacter moi</Card.Title>

        </Card.Body>
        
      </Card>
    </CardGroup>
   
    </div>
     
    

    </div>
    </>
  );
  }